<template>
  <div>
    <a role="button" class="btn btn-primary" @click="submit()"><i class="fas fa-save"></i></a>
    <a v-if="!isEnableFilter" role="button" class="btn btn-primary " @click="btnEnableOrDisable"><i class="fa fa-cog"></i>開啟篩選</a>

    <div v-if="isEnableFilter" >
      <a role="button" class="btn btn-primary " @click="btnEnableOrDisable()"><i class="fa fa-times-circle"></i>關閉篩選</a>
      <a role="button" class="btn btn-primary " @click="btnClear"><i class="fa fa-sync"></i> 清除篩選</a>
      <div class="row" style="width:1300px;margin-top:20px">
        <div class="col-3" v-for="(item,index) in this.GetUniqueGroup1()" :key="index" >
          <a role="button" class="btn btn-primary filterItembutton" @click="FilterByGroup1(item)">{{item}}</a>
        </div>
      </div>


      <div class="row" style="width:1300px">
        <div class="col-3" v-if="currentFilterGroup1 !==''">
          <a role="button" class="btn btn-info filterItembutton" @click="FilterByGroup2('')">全部</a>
        </div>
        <div class="col-3" v-for="(item,index) in this.GetUniqueGroup2(currentFilterGroup1)" :key="index" >
          <a role="button" class="btn btn-info filterItembutton" @click="FilterByGroup2(item)">{{item}}</a>
        </div>
      </div>
    </div>

    <hr>

    <a class="btn btn-primary" @click="DataItemMaster_AddLast"><i class="fas fa-plus-circle"></i></a>
    <table class="table table-hover" id="tblMain">
      <thead class="thead-light">
      <tr>
        <th class="text-center">功能</th>
<!--        <th>啟停用</th>-->
        <th>大分類</th>
        <th>小分類</th>
        <th>題目</th>
      </tr>
      </thead>
      <tbody>
      <template v-for="(masterItem) in datas.Questions">
        <tr :key="masterItem.systemId" v-show="IsShow(masterItem)">
          <td class="text-center" width="280px">
            <a class="btn btn-primary" @click="DataItemMaster_Insert(masterItem)"><i class="fas fa-plus-circle"></i></a>
            <a class="btn btn-danger" @click="DataItemMaster_Remove(masterItem)"><i class="far fa-trash-alt"></i></a>
            <a class="btn btn-primary" @click="DataItemMaster_MoveUp(masterItem)"><i class="fa fa-angle-up"></i> </a>
            <a class="btn btn-primary" @click="DataItemMaster_MoveDown(masterItem)"><i class="fa fa-angle-down"></i> </a>
<!--            <a class="btn btn-primary" v-b-toggle="'collapse-' + masterItem.systemId.substr(0,4)" ><i class="fa fa-bars"></i> </a>-->
          </td>
<!--          <td width="100px" >-->
<!--            <MyButtonEnableDisable v-model="masterItem.IsEnable"></MyButtonEnableDisable>-->
<!--          </td>-->
          <td width="200px">
            <input type="text" class="form-control" placeholder="" v-model="masterItem.group1">
          </td>
          <td width="200px">
            <input type="text" class="form-control" placeholder="" v-model="masterItem.group2">
          </td>
          <td width="" class="">
<!--            flex-fill-->
            <div class="form-inline">
            <input type="text" class="form-control flex-fill" placeholder="" v-model="masterItem.question">

              <a role="button" v-if="haveHtmlContent(masterItem)" class="btn btn-primary " @click="editHtmlContent(masterItem)"><i class="fa fa-pen"></i></a>
              <a role="button" v-if="!haveHtmlContent(masterItem)" class="btn btn-secondary " @click="editHtmlContent(masterItem)"><i class="fa fa-pen"></i></a>

              <MyCodeListSelect v-model="masterItem.answerType" :options="$u.TzsciCode_AnswerSelectType" size="md"></MyCodeListSelect>
              <a role="button" class="btn btn-primary " @click="editAnswer(masterItem)"><i class="fa fa-pen"></i>編輯答案</a>
            </div>
          </td>
        </tr>
      </template>

      </tbody>
    </table>

    <DLGEditor ref="dlgEditor" v-on:returnOk="dlgEditorReturnOK" />
  </div>


</template>


<script>
/**

 **/

import arrayUtil from "../../util/arrayUtil";
import util from "../../util/util";
import MyButtonEnableDisable from "@/views/taylorAdmin/component/MyButtonEnableDisable";
import MyCodeListSelect from "@/views/taylorAdmin/component/MyCodeListSelect";
import _ from "lodash";
import DLGEditor from "@/views/tzsci/component/DLGEditor";
import apiTzsci from "@/views/tzsci/js/apiTzsci";
import {TZQuestion} from "@/views/tzsci/vo/tzVo";

export default {
  components: {DLGEditor, MyCodeListSelect, MyButtonEnableDisable},
  //name: "contentEdit",
  // props: [""],
  data: function () {
    return {
      id: "",
      dataReady: false,
      formData: {
        name: "",
      },
      isEnableFilter: false,
      currentFilterGroup1:"",
      currentFilterGroup2:"",
      datas:{
        /** @type {TZQuestion[]} */
        Questions: [
        ]
      },
    };
  },
  methods: {
    loadData() {
      let that=this;
      let loader=util.ShowLoading(this);
      //
      apiTzsci.api_Admin_Question_Query().then((data)=>{
        let dataApi=data.data.data;

        that.datas.Questions=dataApi;
        util.HideLoading(loader);
      })
    },
    submit(){
      let that=this;
      apiTzsci.api_Admin_Question_Save(this.datas.Questions).then((data)=>{
        alert('儲存成功')
      })
    },

    DataItemMaster_MoveUp(item) {
      arrayUtil.orderMove(false, item.systemId, this.datas.Questions, "systemId", "seq")
    },
    DataItemMaster_MoveDown(item) {
      arrayUtil.orderMove(true, item.systemId, this.datas.Questions, "systemId", "seq")
    },
    DataItemMaster_AddLast() {
      let newItem = new TZQuestion();
      newItem.systemId = util.uuid();

      arrayUtil.orderAppendLast(newItem, this.datas.Questions, "seq")
    },

    DataItemMaster_Insert(currentItem){
      let newItem = new TZQuestion();
      newItem.systemId = util.uuid();

      arrayUtil.orderInsert(newItem,currentItem,this.datas.Questions,"systemId","seq")
    },

    DataItemMaster_Remove(item) {
      arrayUtil.removeByPredicate(this.datas.Questions,s => s.systemId===item.systemId);
    },

    btnEnableOrDisable(){
      this.isEnableFilter=!this.isEnableFilter;
      if (this.isEnableFilter){
        console.log("");
      }else{
        this.currentFilterGroup1="";
        this.currentFilterGroup2="";
      }
    },

    btnClear(){
      this.currentFilterGroup1="";
      this.currentFilterGroup2="";
    },
    FilterByGroup1(group1){
      this.currentFilterGroup1=group1;
      this.currentFilterGroup2="";
    },
    FilterByGroup2(group2){
      this.currentFilterGroup2=group2;
    },
    GetUniqueGroup1(){
      let group1s = this.datas.Questions.map(s=>s.Group1);
      return _.filter(arrayUtil.removeDupicate(group1s), Boolean);
    },
    GetUniqueGroup2(group1){
      let group1Data=this.datas.Questions.filter(s=>s.Group1===group1);
      let group2s = group1Data.map(s=>s.Group2);
      return _.filter(arrayUtil.removeDupicate(group2s), Boolean);
    },
    IsShow(question){
      if (this.currentFilterGroup1 ==="" && this.currentFilterGroup2===""){
        return true;//沒有啟用篩選
      }

      if (this.currentFilterGroup1 !=="" && this.currentFilterGroup2!==""){
        if (question.Group1===this.currentFilterGroup1 && question.Group2===this.currentFilterGroup2) {
          return true;//篩選group1
        }else{
          return false;
        }
      }
      if (this.currentFilterGroup1 !==""){
        if (question.Group1===this.currentFilterGroup1) {
          return true;//篩選group2
        }
      }else{
        return false;
      }


    },
    editHtmlContent(item){
      this.$refs.dlgEditor.callbackItem=item;
      this.$refs.dlgEditor.htmlContent=item.questionDesc;
      this.$refs.dlgEditor.showModal();
    },
    haveHtmlContent(item){
      if (item.questionDesc ){
        return true;
        // if (item.questionDesc.trim() !=="" && item.questionDesc.trim() !=="''"){
        //   return true;
        // }else{
        //   return false;
        // }
      }else{
        return false;
      }
    },
    dlgEditorReturnOK(item){
      item.questionDesc=this.$refs.dlgEditor.htmlContent;
    },
    editAnswer(item){
      this.$router.push({ name: 'AppContentQuestionEdit', query: { questionSystemId: item.systemId }})
    }
  },
  mounted() {
    this.loadData()
  },
}
</script>


<style scoped>
#tblMain{
  width: 1500px;
}
.thisBtnEdit{
  color: white !important;
  margin: 5px;
  width: 40px;
}
.abutton{
  color: white !important;
}
.filterItembutton{
  color: white !important;
  width: 220px;
}
.btn{
  color: white !important;
  margin: 5px;
}
</style>
